import { Script } from 'gatsby';

const ThirdPartyResources = () => {
    const adobeUrl = process.env.GATSBY_//assets.adobedtm.com/b21848b216eb/78836cc116ec/launch-ef4be89f32be.min.js;

    return (
        <>
            <Script src={adobeUrl} async />
            <Script src="https://app-ab41.marketo.com/js/forms2/js/forms2.min.js" async />
            <Script src="https://munchkin.marketo.net/munchkin.js" async />
            {process.env.GATSBY_EH_ENV === 'prod' && <Script
                src="https://js.sentry-cdn.com/d5123a0c141510bfa6ac69244570951d.min.js"
                crossOrigin="anonymous"
                async
            />}
        </>
    );
};

export default ThirdPartyResources;
